import { VuexModule, getModule, Mutation, Action } from 'vuex-module-decorators'
import DynamicModule from '@/decorators/DynamicModule'
import Delivery from '@/dto/deliveries/Delivery'
import deliveryService from '@/services/DeliveryService'
import { Errors } from '@/dto/ErrorsResponse'
import { NotifyHelper } from 'vue-kit'
import DeliveryService from '@/services/DeliveryService'

@DynamicModule
class DeliveryStore extends VuexModule {
  public deliveries: Delivery[] = []
  public deliveryId: number | null = null
  public validationErrors: Errors = {}

  get delivery(): Delivery | null {
    return (
      this.deliveries.find(
        (delivery: Delivery) => this.deliveryId === delivery.id
      ) || null
    )
  }

  get hasErrors(): boolean {
    return Object.keys(this.validationErrors).length > 0
  }

  @Mutation
  public setDeliveries(deliveries: Delivery[]) {
    this.deliveries = deliveries
  }

  @Mutation
  public selectDelivery(deliveryId: number | null) {
    this.deliveryId = deliveryId
  }

  @Mutation
  public addDeliveryToList(model: Delivery) {
    this.deliveries.unshift(model)
  }

  @Mutation
  public updateDeliveryInList(model: Delivery) {
    const index = this.deliveries.findIndex(
      (delivery: Delivery) => delivery.id === model.id
    )
    this.deliveries.splice(index, 1, model)
  }

  @Mutation
  public removeDeliveryFromList(deliveryId: number) {
    this.deliveries.splice(
      this.deliveries.findIndex((delivery: Delivery) => {
        return delivery.id === deliveryId
      }),
      1
    )
  }

  @Mutation
  public setErrors(errors: Errors) {
    this.validationErrors = errors
  }

  @Action({ rawError: true })
  async loadDeliveries(shipmentPointId: string | null) {
    if (shipmentPointId === null) {
      this.setDeliveries([])
      return
    }

    return DeliveryService.getDeliveries(
      parseInt(shipmentPointId)
    ).then(deliveries => this.setDeliveries(deliveries))
  }

  @Action({ rawError: true })
  async saveDelivery(model: Delivery) {
    return deliveryService
      .saveDelivery(model)
      .then((delivery: Delivery) => {
        NotifyHelper.success('Доставка сохранена!')

        if (model.id) {
          this.updateDeliveryInList(delivery)
        } else {
          this.addDeliveryToList(delivery)
        }

        return delivery
      })
      .catch(error => {
        if (!error.response.data.errors) {
          NotifyHelper.error('Ошибка сервера. Обратитесь к разработчикам!')
        }

        throw error.response.data.errors
      })
  }

  @Action
  public removeDelivery(deliveryId: number) {
    return deliveryService
      .removeDelivery(deliveryId)
      .then(() => {
        NotifyHelper.success('Доставка удалена!')
        this.removeDeliveryFromList(deliveryId)
      })
      .catch(() => {
        NotifyHelper.error('Ошибка сервера. Обратитесь к разработчикам!')
      })
  }
}

export default getModule(DeliveryStore)
